export default "__VITE_ASSET__DDy_f7m5__"